module.exports = ".ck.ck-block-toolbar-button{transform:translateX(calc(-1*var(--ck-spacing-large)))}"